module.exports = __webpack_public_path__ + "img/1494.a564a282.gif";